import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { StarRow } from './StarRow';
import type { Review } from '../../types/blackout';
export function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <article className="flex h-full border border-gunmetal bg-carbon" data-id="element-254" data-mp="soxyrbqpajfi">
      <div className="w-[38%] shrink-0 border-r border-gunmetal bg-obsidian" data-id="element-255" data-mp="oo4c0lozvao7">
        <img src={review.image} alt={review.imageAlt} loading="lazy" className="h-full min-h-[180px] w-full object-cover grayscale" data-id="element-256" data-mp="om1bv8u4o15r" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col p-4" data-id="element-257" data-mp="1gg3fru8dnhre">
        <div className="flex items-center justify-between gap-2" data-id="element-258" data-mp="1ccx6setvrch8">
          <StarRow rating={review.rating} data-id="element-259" data-mp="17elzaar25e26" />
          <span className="truncate text-[10px] font-medium uppercase tracking-[0.14em] text-steel" data-id="element-260" data-mp="17du2wxpmzcau">
            {review.topic}
          </span>
        </div>
        <p className="mt-3 text-[14px] leading-relaxed text-bone/90" data-id="element-261" data-mp="3s54bwz8qsf0v">“{review.quote}”</p>
        <div className="mt-auto pt-4" data-id="element-262" data-mp="21jqtefvdli4q">
          <p className="text-sm font-semibold text-bone" data-id="element-263" data-mp="21ktjilkvjgjl">— {review.name}</p>
          <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[11px] text-steel" data-id="element-264" data-mp="26ilczk163apw">
            {review.verified && <span className="inline-flex items-center gap-1 text-bone/85" data-id="element-265" data-mp="1siaim70nfdzz">
                <BadgeCheck className="h-3.5 w-3.5" aria-hidden="true" data-id="element-266" data-mp="1xhdn9qcpvi7f" />
                Verified buyer
              </span>}
            <span data-id="element-267" data-mp="1irxyuh0nrouw">
              {review.location} · {review.purchase}
            </span>
          </p>
        </div>
      </div>
    </article>;
}